import { render, staticRenderFns } from "./LinksItem.vue?vue&type=template&id=64be3ab8&"
import script from "./LinksItem.vue?vue&type=script&lang=js&"
export * from "./LinksItem.vue?vue&type=script&lang=js&"
import style0 from "./LinksItem.vue?vue&type=style&index=0&id=64be3ab8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports